import { render, staticRenderFns } from "./StaffBasePage.vue?vue&type=template&id=722ed902&scoped=true&"
import script from "./StaffBasePage.vue?vue&type=script&lang=js&"
export * from "./StaffBasePage.vue?vue&type=script&lang=js&"
import style0 from "./StaffBasePage.vue?vue&type=style&index=0&id=722ed902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ed902",
  null
  
)

export default component.exports